(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-vyer"]) return;
  try {
    

(() => {
  if (window.estoreCollectionViews) return;
  window.estoreCollectionViews = true;
  const initialized = new WeakSet();
  const key = 'estore:collection-view:v2';
  function initializeViews() {
    document.querySelectorAll('[data-estore-views]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      let mode = root.dataset.estoreView;
      try { const saved = localStorage.getItem(key); if (saved === 'grid' || saved === 'list') mode = saved; } catch {}
      function sync() {
        root.dataset.estoreView = mode;
        root.querySelectorAll('[data-estore-view-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.estoreViewChoice === mode)));
      }
      for (const eventName of ['filters:changed', 'pagination:link:clicked']) {
        root.addEventListener(eventName, event => {
          if (!event.detail || !new URL(location.href).searchParams.has('view')) return;
          const params = new URLSearchParams(event.detail.searchParams);
          params.set('view', new URL(location.href).searchParams.get('view'));
          event.detail.searchParams = params.toString();
        }, true);
      }
      root.addEventListener('click', event => {
        const button = event.target instanceof Element ? event.target.closest('[data-estore-view-choice]') : null;
        if (!button || !root.contains(button)) return;
        mode = button.dataset.estoreViewChoice;
        sync();
        try { localStorage.setItem(key, mode); } catch {}
      });
      new MutationObserver(sync).observe(root, {childList: true, subtree: true});
      sync();
      root.setAttribute('data-estore-view-ready', '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeViews);
  else initializeViews();
  document.addEventListener('shopify:section:load', initializeViews);
})();

(() => {
  if (window.estoreCollectionNavigationGuard) return;
  window.estoreCollectionNavigationGuard = true;

  function resetCollectionFilters(event) {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download')) return;
    const current = new URL(window.location.href);
    const target = new URL(link.href, current);
    if (target.origin !== current.origin) return;
    const collectionPath = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/]+)(?:\/.*)?$/i;
    const currentCollection = current.pathname.match(collectionPath);
    const targetCollection = target.pathname.match(collectionPath);
    if (!currentCollection || !targetCollection || currentCollection[1] === targetCollection[1]) return;
    const filterKeys = [...target.searchParams.keys()].filter(key => key.startsWith('filter.'));
    if (!filterKeys.length) return;
    filterKeys.forEach(key => target.searchParams.delete(key));
    target.searchParams.delete('page');
    link.href = target.href;
  }

  document.addEventListener('click', resetCollectionFilters, true);
  document.addEventListener('auxclick', resetCollectionFilters, true);
})();

(() => {
  if (window.estoreInfiniteCollections) return;

  window.estoreInfiniteCollections = true;

  const instances = new WeakMap();

  function initialize(root) {
    if (instances.has(root) || !('IntersectionObserver' in window)) return;

    let grid;
    let pagination;
    let controls;
    let button;
    let status;
    let spinner;
    let next;
    let controller;

    let busy = false;
    let automatic = true;
    let generation = 0;

    const seen = new Set();

    const observer = new IntersectionObserver(entries => {
      if (automatic && entries.some(entry => entry.isIntersecting)) {
        load();
      }
    }, {
      rootMargin: '400px 0px'
    });

    function cancel() {
      generation++;
      controller?.abort();
      controller = null;
      busy = false;
      grid?.removeAttribute('aria-busy');
    }

    function reset() {
      if (root.hasAttribute('loading')) return;

      const currentGrid = root.querySelector(
        '#FilterProductGrid > .product-grid'
      );

      const currentPagination = root.querySelector(
        '#FilterProductGrid .pagination'
      );

      if (
        currentGrid === grid &&
        currentPagination === pagination
      ) return;

      cancel();
      observer.disconnect();

      controls?.remove();
      pagination?.classList.remove('estore-infinite-native');

      grid = currentGrid;
      pagination = currentPagination;

      next = pagination?.querySelector('a[rel="next"]')?.href;

      automatic = true;
      seen.clear();

      if (!grid || !next) return;

      controls = document.createElement('div');
      controls.className = 'estore-infinite-controls';

      button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary';
      button.textContent = root.dataset.nextLabel;
      button.addEventListener('click', () => load(true));

      status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');

      spinner = document.createElement('span');
      spinner.hidden = true;
      spinner.setAttribute('aria-hidden', 'true');
      spinner.innerHTML =
        '<svg class="spinner" viewBox="0 0 24 24">' +
        '<circle class="spinner__value" cx="12" cy="12" r="10" />' +
        '</svg>';

      controls.append(button, spinner, status);
      grid.parentElement.append(controls);

      pagination.classList.add('estore-infinite-native');

      observer.observe(controls);
    }

    async function load(manual = false) {
      if (
        busy ||
        !next ||
        !grid?.isConnected ||
        root.hasAttribute('loading')
      ) return;

      const url = new URL(next, location.href);

      if (
        url.origin !== location.origin ||
        url.pathname !== location.pathname ||
        seen.has(url.href)
      ) return;

      const originalURL = url.href;
      const version = generation;
      const targetGrid = grid;
      const targetControls = controls;

      const aborter = new AbortController();
      controller = aborter;

      const timer = setTimeout(() => aborter.abort(), 20000);

      busy = true;
      button.disabled = true;
      spinner.hidden = false;

      targetGrid.setAttribute('aria-busy', 'true');
      observer.unobserve(targetControls);

      try {
        url.searchParams.set(
          'section_id',
          root.getAttribute('section-id')
        );

        const response = await fetch(url, {
          signal: aborter.signal,
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Collection request failed');
        }

        const html = new DOMParser().parseFromString(
          await response.text(),
          'text/html'
        );

        const incomingRoot = html.querySelector(
          'loess-product-filters[data-estore-infinite]'
        );

        const incomingGrid = incomingRoot?.querySelector(
          '#FilterProductGrid > .product-grid'
        );

        const incomingPagination = incomingRoot?.querySelector(
          '#FilterProductGrid .pagination'
        );

        if (!incomingGrid || !incomingGrid.children.length) {
          throw new Error('Missing collection grid');
        }

        if (
          version !== generation ||
          !targetGrid.isConnected ||
          root.hasAttribute('loading')
        ) return;

        const products = new Set(
          Array.from(
            targetGrid.querySelectorAll('a[href*="/products/"]'),
            a => new URL(a.href).pathname
          )
        );

        const cards = Array.from(incomingGrid.children).filter(card => {
          const link = card.querySelector('a[href*="/products/"]');

          if (!link) return true;

          const path = new URL(link.href).pathname;

          if (products.has(path)) return false;

          products.add(path);

          return true;
        });

        for (const card of cards) {
          card.querySelectorAll('.card').forEach(item => {
            item.style.opacity = '1';
          });
        }

        targetGrid.append(...cards);
        seen.add(originalURL);

        const incomingNext = incomingPagination?.querySelector(
          'a[rel="next"]'
        )?.href;

        next = incomingNext
          ? new URL(incomingNext, originalURL).href
          : null;

        if (next) {
          const clean = new URL(next);
          clean.searchParams.delete('section_id');
          next = clean.href;
        }

        status.textContent =
          `${root.dataset.nextLabel}: ` +
          `${new URL(originalURL).searchParams.get('page') || ''}`;

        if (manual && cards.length) {
          const focusTarget = cards[0].querySelector(
            'a[href*="/products/"]'
          );

          focusTarget?.focus({
            preventScroll: true
          });
        }

        automatic = true;

        if (!next) {
          targetControls.hidden = true;
        }
      } catch (error) {
        if (
          version === generation &&
          targetGrid.isConnected
        ) {
          automatic = false;
          pagination?.classList.remove('estore-infinite-native');
        }
      } finally {
        clearTimeout(timer);

        if (version === generation) {
          busy = false;
          controller = null;

          targetGrid.removeAttribute('aria-busy');

          button.disabled = false;
          spinner.hidden = true;

          if (
            next &&
            automatic &&
            targetControls.isConnected
          ) {
            observer.observe(targetControls);
          }
        }
      }
    }

    const changes = new MutationObserver(() => {
      if (!root.isConnected) {
        cancel();
        observer.disconnect();
        changes.disconnect();
        return;
      }

      if (root.hasAttribute('loading')) {
        cancel();
        observer.disconnect();
        return;
      }

      reset();
    });

    changes.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['loading']
    });

    instances.set(root, true);
    reset();
  }

  const start = () => {
    document.querySelectorAll(
      'loess-product-filters[data-estore-infinite]'
    ).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    

(() => {
  if (window.estoreCollectionViews) return;
  window.estoreCollectionViews = true;
  const initialized = new WeakSet();
  const key = 'estore:collection-view:v2';
  function initializeViews() {
    document.querySelectorAll('[data-estore-views]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      let mode = root.dataset.estoreView;
      try { const saved = localStorage.getItem(key); if (saved === 'grid' || saved === 'list') mode = saved; } catch {}
      function sync() {
        root.dataset.estoreView = mode;
        root.querySelectorAll('[data-estore-view-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.estoreViewChoice === mode)));
      }
      for (const eventName of ['filters:changed', 'pagination:link:clicked']) {
        root.addEventListener(eventName, event => {
          if (!event.detail || !new URL(location.href).searchParams.has('view')) return;
          const params = new URLSearchParams(event.detail.searchParams);
          params.set('view', new URL(location.href).searchParams.get('view'));
          event.detail.searchParams = params.toString();
        }, true);
      }
      root.addEventListener('click', event => {
        const button = event.target instanceof Element ? event.target.closest('[data-estore-view-choice]') : null;
        if (!button || !root.contains(button)) return;
        mode = button.dataset.estoreViewChoice;
        sync();
        try { localStorage.setItem(key, mode); } catch {}
      });
      new MutationObserver(sync).observe(root, {childList: true, subtree: true});
      sync();
      root.setAttribute('data-estore-view-ready', '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeViews);
  else initializeViews();
  document.addEventListener('shopify:section:load', initializeViews);
})();

(() => {
  if (window.estoreCollectionNavigationGuard) return;
  window.estoreCollectionNavigationGuard = true;

  function resetCollectionFilters(event) {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download')) return;
    const current = new URL(window.location.href);
    const target = new URL(link.href, current);
    if (target.origin !== current.origin) return;
    const collectionPath = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/]+)(?:\/.*)?$/i;
    const currentCollection = current.pathname.match(collectionPath);
    const targetCollection = target.pathname.match(collectionPath);
    if (!currentCollection || !targetCollection || currentCollection[1] === targetCollection[1]) return;
    const filterKeys = [...target.searchParams.keys()].filter(key => key.startsWith('filter.'));
    if (!filterKeys.length) return;
    filterKeys.forEach(key => target.searchParams.delete(key));
    target.searchParams.delete('page');
    link.href = target.href;
  }

  document.addEventListener('click', resetCollectionFilters, true);
  document.addEventListener('auxclick', resetCollectionFilters, true);
})();

(() => {
  if (window.estoreInfiniteCollections) return;

  window.estoreInfiniteCollections = true;

  const instances = new WeakMap();

  function initialize(root) {
    if (instances.has(root) || !('IntersectionObserver' in window)) return;

    let grid;
    let pagination;
    let controls;
    let button;
    let status;
    let spinner;
    let next;
    let controller;

    let busy = false;
    let automatic = true;
    let generation = 0;

    const seen = new Set();

    const observer = new IntersectionObserver(entries => {
      if (automatic && entries.some(entry => entry.isIntersecting)) {
        load();
      }
    }, {
      rootMargin: '400px 0px'
    });

    function cancel() {
      generation++;
      controller?.abort();
      controller = null;
      busy = false;
      grid?.removeAttribute('aria-busy');
    }

    function reset() {
      if (root.hasAttribute('loading')) return;

      const currentGrid = root.querySelector(
        '#FilterProductGrid > .product-grid'
      );

      const currentPagination = root.querySelector(
        '#FilterProductGrid .pagination'
      );

      if (
        currentGrid === grid &&
        currentPagination === pagination
      ) return;

      cancel();
      observer.disconnect();

      controls?.remove();
      pagination?.classList.remove('estore-infinite-native');

      grid = currentGrid;
      pagination = currentPagination;

      next = pagination?.querySelector('a[rel="next"]')?.href;

      automatic = true;
      seen.clear();

      if (!grid || !next) return;

      controls = document.createElement('div');
      controls.className = 'estore-infinite-controls';

      button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary';
      button.textContent = root.dataset.nextLabel;
      button.addEventListener('click', () => load(true));

      status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');

      spinner = document.createElement('span');
      spinner.hidden = true;
      spinner.setAttribute('aria-hidden', 'true');
      spinner.innerHTML =
        '<svg class="spinner" viewBox="0 0 24 24">' +
        '<circle class="spinner__value" cx="12" cy="12" r="10" />' +
        '</svg>';

      controls.append(button, spinner, status);
      grid.parentElement.append(controls);

      pagination.classList.add('estore-infinite-native');

      observer.observe(controls);
    }

    async function load(manual = false) {
      if (
        busy ||
        !next ||
        !grid?.isConnected ||
        root.hasAttribute('loading')
      ) return;

      const url = new URL(next, location.href);

      if (
        url.origin !== location.origin ||
        url.pathname !== location.pathname ||
        seen.has(url.href)
      ) return;

      const originalURL = url.href;
      const version = generation;
      const targetGrid = grid;
      const targetControls = controls;

      const aborter = new AbortController();
      controller = aborter;

      const timer = setTimeout(() => aborter.abort(), 20000);

      busy = true;
      button.disabled = true;
      spinner.hidden = false;

      targetGrid.setAttribute('aria-busy', 'true');
      observer.unobserve(targetControls);

      try {
        url.searchParams.set(
          'section_id',
          root.getAttribute('section-id')
        );

        const response = await fetch(url, {
          signal: aborter.signal,
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Collection request failed');
        }

        const html = new DOMParser().parseFromString(
          await response.text(),
          'text/html'
        );

        const incomingRoot = html.querySelector(
          'loess-product-filters[data-estore-infinite]'
        );

        const incomingGrid = incomingRoot?.querySelector(
          '#FilterProductGrid > .product-grid'
        );

        const incomingPagination = incomingRoot?.querySelector(
          '#FilterProductGrid .pagination'
        );

        if (!incomingGrid || !incomingGrid.children.length) {
          throw new Error('Missing collection grid');
        }

        if (
          version !== generation ||
          !targetGrid.isConnected ||
          root.hasAttribute('loading')
        ) return;

        const products = new Set(
          Array.from(
            targetGrid.querySelectorAll('a[href*="/products/"]'),
            a => new URL(a.href).pathname
          )
        );

        const cards = Array.from(incomingGrid.children).filter(card => {
          const link = card.querySelector('a[href*="/products/"]');

          if (!link) return true;

          const path = new URL(link.href).pathname;

          if (products.has(path)) return false;

          products.add(path);

          return true;
        });

        for (const card of cards) {
          card.querySelectorAll('.card').forEach(item => {
            item.style.opacity = '1';
          });
        }

        targetGrid.append(...cards);
        seen.add(originalURL);

        const incomingNext = incomingPagination?.querySelector(
          'a[rel="next"]'
        )?.href;

        next = incomingNext
          ? new URL(incomingNext, originalURL).href
          : null;

        if (next) {
          const clean = new URL(next);
          clean.searchParams.delete('section_id');
          next = clean.href;
        }

        status.textContent =
          `${root.dataset.nextLabel}: ` +
          `${new URL(originalURL).searchParams.get('page') || ''}`;

        if (manual && cards.length) {
          const focusTarget = cards[0].querySelector(
            'a[href*="/products/"]'
          );

          focusTarget?.focus({
            preventScroll: true
          });
        }

        automatic = true;

        if (!next) {
          targetControls.hidden = true;
        }
      } catch (error) {
        if (
          version === generation &&
          targetGrid.isConnected
        ) {
          automatic = false;
          pagination?.classList.remove('estore-infinite-native');
        }
      } finally {
        clearTimeout(timer);

        if (version === generation) {
          busy = false;
          controller = null;

          targetGrid.removeAttribute('aria-busy');

          button.disabled = false;
          spinner.hidden = true;

          if (
            next &&
            automatic &&
            targetControls.isConnected
          ) {
            observer.observe(targetControls);
          }
        }
      }
    }

    const changes = new MutationObserver(() => {
      if (!root.isConnected) {
        cancel();
        observer.disconnect();
        changes.disconnect();
        return;
      }

      if (root.hasAttribute('loading')) {
        cancel();
        observer.disconnect();
        return;
      }

      reset();
    });

    changes.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['loading']
    });

    instances.set(root, true);
    reset();
  }

  const start = () => {
    document.querySelectorAll(
      'loess-product-filters[data-estore-infinite]'
    ).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();
})();
